import { render, staticRenderFns } from "./ShiftUserAddDialog.vue?vue&type=template&id=2ab444ea"
import script from "./ShiftUserAddDialog.vue?vue&type=script&lang=js"
export * from "./ShiftUserAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports